import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { DeviceExchangeRequest } from '@/api/handlers/resources/auth/requests';
import type { DeviceExchangeResponse } from '@/api/handlers/resources/auth/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { setDeviceSession } from '@/utils';

/**
 * Mutation behind the enrollment screen. Exchanges the branch's static API token
 * for a device session and, on success, persists it so the terminal is enrolled.
 * The query function never rejects — the caller branches on `result.success` and
 * shows a generic error for a bad / rotated token.
 */
export const useDeviceExchangeMutation = () => {
    const { apiClient } = useApi();

    return useMutation<
        ApiResponse<DeviceExchangeResponse>,
        Error,
        DeviceExchangeRequest
    >({
        mutationFn: (body) => apiClient.auth.exchangeDevice(body),
        onSuccess: (result) => {
            if (result.success) {
                setDeviceSession(result.response);
            }
        },
    });
};
